import { render } from "./authLayout.vue?vue&type=template&id=e1c0ef92"
import script from "./authLayout.vue?vue&type=script&lang=js"
export * from "./authLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__